
      import UserVerified from './user-verified.vue'
      import type { App, Plugin } from 'vue'

      export const UserVerifiedPlugin: Plugin = {
        install(app: App) {
          app.component('UserVerified', UserVerified)
        },
      }
      export { UserVerified }
      